import React, { useState } from 'react';
import { ShoppingCart, Wallet, X, Smartphone, Laptop, Watch, ExternalLink } from 'lucide-react';

const CryptoStore = () => {
  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);
  const [showCheckout, setShowCheckout] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeImages, setActiveImages] = useState({});
  const [customerEmail, setCustomerEmail] = useState('');
  const [flippedCards, setFlippedCards] = useState({});
  const [deliveryAddress, setDeliveryAddress] = useState({
    name: '',
    phone: '',
    street: '',
    city: '',
    state: '',
    zip: '',
    country: ''
  });

  // Backend API URL
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

  const products = [
    { 
      id: 1, 
      name: 'iPhone 15 Pro', 
      category: 'Mobile', 
      price: 999, 
      icon: Smartphone,
      images: [
        'https://images.unsplash.com/photo-1696446701796-da61225697cc?w=400',
        'https://images.unsplash.com/photo-1695048133142-1a20484d2569?w=400',
        'https://images.unsplash.com/photo-1695048064942-d00c4d7e2365?w=400'
      ],
      specs: {
      display: '18" 240Hz QHD+ (2560x1600)',
      processor: 'Intel Core Ultra 9-275HX',
      ram: '64GB DDR5',
      storage: 'Dual SSD Configuration',
      graphics: 'NVIDIA GeForce RTX 5090',
      battery: '90Wh',
      weight: '3.1 kg',
      os: 'Windows 11'
      }
    },
    { 
      id: 2, 
      name: 'Samsung Galaxy S24', 
      category: 'Mobile', 
      price: 899, 
      icon: Smartphone,
      images: [
        'https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?w=400',
        'https://images.unsplash.com/photo-1598327105666-5b89351aff97?w=400',
        'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=400'
      ],
      specs: {
      display: '18" 240Hz QHD+ (2560x1600)',
      processor: 'Intel Core Ultra 9-275HX',
      ram: '64GB DDR5',
      storage: 'Dual SSD Configuration',
      graphics: 'NVIDIA GeForce RTX 5090',
      battery: '90Wh',
      weight: '3.1 kg',
      os: 'Windows 11'
      }
    },
    { 
      id: 3, 
      name: 'MacBook Pro 14"', 
      category: 'Laptop', 
      price: 1999, 
      icon: Laptop,
      images: [
        'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=400',
        'https://images.unsplash.com/photo-1611186871348-b1ce696e52c9?w=400',
        'https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=400'
      ],
      specs: {
      display: '18" 240Hz QHD+ (2560x1600)',
      processor: 'Intel Core Ultra 9-275HX',
      ram: '64GB DDR5',
      storage: 'Dual SSD Configuration',
      graphics: 'NVIDIA GeForce RTX 5090',
      battery: '90Wh',
      weight: '3.1 kg',
      os: 'Windows 11'
      }
    },
    { 
      id: 4, 
      name: 'Dell XPS 15', 
      category: 'Laptop', 
      price: 1599, 
      icon: Laptop,
      images: [
        'https://images.unsplash.com/photo-1593642632823-8f785ba67e45?w=400',
        'https://images.unsplash.com/photo-1588872657578-7efd1f1555ed?w=400',
        'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=400'
      ],
      specs: {
      display: '18" 240Hz QHD+ (2560x1600)',
      processor: 'Intel Core Ultra 9-275HX',
      ram: '64GB DDR5',
      storage: 'Dual SSD Configuration',
      graphics: 'NVIDIA GeForce RTX 5090',
      battery: '90Wh',
      weight: '3.1 kg',
      os: 'Windows 11'
      }
    },
    { 
      id: 5, 
      name: 'Apple Watch Series 9', 
      category: 'Watch', 
      price: 399, 
      icon: Watch,
      images: [
        'https://images.unsplash.com/photo-1579586337278-3befd40fd17a?w=400',
        'https://images.unsplash.com/photo-1434493789847-2f02dc6ca35d?w=400',
        'https://images.unsplash.com/photo-1510017803434-a899398421b3?w=400'
      ],
      specs: {
      display: '18" 240Hz QHD+ (2560x1600)',
      processor: 'Intel Core Ultra 9-275HX',
      ram: '64GB DDR5',
      storage: 'Dual SSD Configuration',
      graphics: 'NVIDIA GeForce RTX 5090',
      battery: '90Wh',
      weight: '3.1 kg',
      os: 'Windows 11'
      }
    },
    { 
      id: 6, 
      name: 'Samsung Galaxy Watch 6', 
      category: 'Watch', 
      price: 299, 
      icon: Watch,
      images: [
        'https://images.unsplash.com/photo-1617043786394-f977fa12eddf?w=400',
        'https://images.unsplash.com/photo-1508685096489-7aacd43bd3b1?w=400',
        'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400'
      ],
      specs: {
      display: '18" 240Hz QHD+ (2560x1600)',
      processor: 'Intel Core Ultra 9-275HX',
      ram: '64GB DDR5',
      storage: 'Dual SSD Configuration',
      graphics: 'NVIDIA GeForce RTX 5090',
      battery: '90Wh',
      weight: '3.1 kg',
      os: 'Windows 11'
      }
    },
  ];

  const cryptoOptions = [
    { id: 'bitcoin', name: 'Bitcoin', symbol: 'BTC', color: 'bg-orange-500' },
    { id: 'ethereum', name: 'Ethereum', symbol: 'ETH', color: 'bg-purple-500' },
    { id: 'usdc', name: 'USD Coin', symbol: 'USDC', color: 'bg-blue-500' },
    { id: 'tether', name: 'Tether', symbol: 'USDT', color: 'bg-green-500' },
  ];

  const addToCart = (product) => {
    const existing = cart.find(item => item.id === product.id);
    if (existing) {
      setCart(cart.map(item => 
        item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
      ));
    } else {
      setCart([...cart, { ...product, quantity: 1 }]);
    }
  };

  const toggleCardFlip = (productId) => {
  setFlippedCards(prev => ({
    ...prev,
    [productId]: !prev[productId]
  }));
};

  const removeFromCart = (productId) => {
    setCart(cart.filter(item => item.id !== productId));
  };

  const updateQuantity = (productId, change) => {
    setCart(cart.map(item => {
      if (item.id === productId) {
        const newQuantity = item.quantity + change;
        return newQuantity > 0 ? { ...item, quantity: newQuantity } : item;
      }
      return item;
    }).filter(item => item.quantity > 0));
  };

  const getTotal = () => {
    return cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  };

  const generateOrderId = () => {
    return `ORD-${Date.now()}-${Math.random().toString(36).substr(2, 9).toUpperCase()}`;
  };

  const handleCheckout = () => {
    if (cart.length === 0) {
      setError('Your cart is empty');
      return;
    }
    setShowCart(false);
    setShowCheckout(true);
    setError(null);
  };

  const createCryptoPayment = async (selectedCrypto) => {
    // Validate address fields
    if (!deliveryAddress.name || !deliveryAddress.street || !deliveryAddress.city || 
        !deliveryAddress.zip || !deliveryAddress.country) {
      setError('Please fill in all required address fields');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const orderId = generateOrderId();
      const total = getTotal();

      const response = await fetch(`${API_URL}/api/create-charge`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          amount: total,
          currency: 'USD',
          orderId: orderId,
          customerEmail: customerEmail || 'guest@example.com',
          customerName: deliveryAddress.name,
          customerPhone: deliveryAddress.phone,
          deliveryAddress: {
            street: deliveryAddress.street,
            city: deliveryAddress.city,
            state: deliveryAddress.state,
            zip: deliveryAddress.zip,
            country: deliveryAddress.country
          },
          items: cart.map(item => ({
            name: item.name,
            quantity: item.quantity,
            price: item.price
          }))
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to create payment');
      }

      const data = await response.json();

      setPaymentData({
        orderId: orderId,
        chargeId: data.chargeId,
        chargeCode: data.chargeCode,
        hostedUrl: data.hostedUrl,
        addresses: data.addresses,
        pricing: data.pricing,
        selectedCrypto: selectedCrypto
      });

    } catch (err) {
      console.error('Payment creation error:', err);
      setError(err.message || 'Failed to create payment. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const openCoinbasePayment = () => {
    if (paymentData?.hostedUrl) {
      window.open(paymentData.hostedUrl, '_blank');
    }
  };

  const resetStore = () => {
    setCart([]);
    setShowCart(false);
    setShowCheckout(false);
    setPaymentData(null);
    setError(null);
    setCustomerEmail('');
    setDeliveryAddress({
      name: '',
      phone: '',
      street: '',
      city: '',
      state: '',
      zip: '',
      country: ''
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      {/* Header */}
      <header className="bg-slate-800/50 backdrop-blur-sm border-b border-slate-700 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <Wallet className="w-8 h-8 text-cyan-400" />
            <h1 className="text-2xl font-bold text-white">CryptoTech Store</h1>
          </div>
          <button
            onClick={() => setShowCart(true)}
            className="relative bg-cyan-500 hover:bg-cyan-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
          >
            <ShoppingCart className="w-5 h-5" />
            {cart.length > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs w-6 h-6 rounded-full flex items-center justify-center">
                {cart.reduce((sum, item) => sum + item.quantity, 0)}
              </span>
            )}
          </button>
        </div>
      </header>

      {/* Products Grid */}
      <main className="max-w-7xl mx-auto px-4 py-8">
        <h2 className="text-3xl font-bold text-white mb-8">Featured Products</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map(product => {
  const currentImageIndex = activeImages[product.id] || 0;
  const isFlipped = flippedCards[product.id];
  
  return (
    <div key={product.id} className="relative h-[500px]" style={{ perspective: '1000px' }}>
      <div 
        className={`relative w-full h-full transition-transform duration-500 transform-style-3d ${
          isFlipped ? 'rotate-y-180' : ''
        }`}
        style={{
          transformStyle: 'preserve-3d',
          transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)'
        }}
      >
        {/* FRONT SIDE */}
        <div 
          className="absolute w-full h-full backface-hidden"
          style={{ backfaceVisibility: 'hidden' }}
        >
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 border border-slate-700 hover:border-cyan-500 transition-all hover:shadow-xl hover:shadow-cyan-500/20 h-full flex flex-col">
            <div className="mb-4">
              <div className="relative w-full h-48 bg-slate-700 rounded-lg overflow-hidden mb-3">
                <img 
                  src={product.images[currentImageIndex]} 
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex gap-2 justify-center">
                {product.images.map((img, idx) => (
                  <button
                    key={idx}
                    onClick={() => setActiveImages({...activeImages, [product.id]: idx})}
                    className={`w-16 h-16 rounded-md overflow-hidden border-2 transition-all ${
                      currentImageIndex === idx ? 'border-cyan-500' : 'border-slate-600 opacity-60 hover:opacity-100'
                    }`}
                  >
                    <img src={img} alt="" className="w-full h-full object-cover" />
                  </button>
                ))}
              </div>
            </div>
            
            <h3 className="text-xl font-semibold text-white mb-2">{product.name}</h3>
            <p className="text-slate-400 mb-4">{product.category}</p>
            
            <div className="mt-auto space-y-3">
              <div className="flex justify-between items-end">
                <button
                  onClick={() => toggleCardFlip(product.id)}
                  className="text-cyan-400 hover:text-cyan-300 underline text-sm transition-colors"
                >
                  More info →
                </button>
                <span className="text-2xl font-bold text-cyan-400">${product.price}</span>
              </div>
              
              <button
                onClick={() => addToCart(product)}
                className="w-full bg-cyan-500 hover:bg-cyan-600 text-white px-4 py-2 rounded-lg transition-colors"
              >
                Add to Cart
              </button>
            </div>
          </div>
        </div>

        {/* BACK SIDE - Technical Specs */}
        <div 
          className="absolute w-full h-full backface-hidden"
          style={{ 
            backfaceVisibility: 'hidden',
            transform: 'rotateY(180deg)'
          }}
        >
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 border border-cyan-500 h-full flex flex-col">
            <h3 className="text-xl font-semibold text-white mb-4 border-b border-slate-600 pb-3">
              Technical Specifications
            </h3>
            
            <div className="space-y-3 flex-1 overflow-y-auto">
              {product.specs && Object.entries(product.specs).map(([key, value]) => (
                <div key={key} className="flex justify-between items-start">
                  <span className="text-slate-400 capitalize text-sm">
                    {key.replace(/([A-Z])/g, ' $1').trim()}:
                  </span>
                  <span className="text-white text-sm text-right ml-2">{value}</span>
                </div>
              ))}
            </div>
            
            <div className="mt-4 space-y-3 pt-4 border-t border-slate-600">
              <div className="flex items-center justify-between">
                <span className="text-2xl font-bold text-cyan-400">${product.price}</span>
              </div>
              
              <div className="flex gap-2">
                <button
                  onClick={() => toggleCardFlip(product.id)}
                  className="flex-1 bg-slate-700 hover:bg-slate-600 text-white px-4 py-2 rounded-lg transition-colors"
                >
                  Back
                </button>
                <button
                  onClick={() => {
                    addToCart(product);
                    toggleCardFlip(product.id);
                  }}
                  className="flex-1 bg-cyan-500 hover:bg-cyan-600 text-white px-4 py-2 rounded-lg transition-colors"
                >
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
})}
        </div>
      </main>

      {/* Cart Modal */}
      {showCart && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-slate-800 rounded-xl max-w-2xl w-full max-h-[80vh] overflow-auto border border-slate-700">
            <div className="sticky top-0 bg-slate-800 p-6 border-b border-slate-700 flex justify-between items-center">
              <h2 className="text-2xl font-bold text-white">Shopping Cart</h2>
              <button onClick={() => setShowCart(false)} className="text-slate-400 hover:text-white">
                <X className="w-6 h-6" />
              </button>
            </div>
            
            <div className="p-6">
              {cart.length === 0 ? (
                <p className="text-slate-400 text-center py-8">Your cart is empty</p>
              ) : (
                <>
                  {cart.map(item => (
                    <div key={item.id} className="flex items-center justify-between py-4 border-b border-slate-700">
                      <div className="flex items-center gap-4">
                        <img src={item.images[0]} alt={item.name} className="w-16 h-16 object-cover rounded-lg" />
                        <div>
                          <h3 className="text-white font-semibold">{item.name}</h3>
                          <p className="text-slate-400">${item.price}</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-4">
                        <div className="flex items-center gap-2 bg-slate-700 rounded-lg">
                          <button
                            onClick={() => updateQuantity(item.id, -1)}
                            className="px-3 py-1 text-white hover:bg-slate-600 rounded-l-lg"
                          >
                            -
                          </button>
                          <span className="px-3 text-white">{item.quantity}</span>
                          <button
                            onClick={() => updateQuantity(item.id, 1)}
                            className="px-3 py-1 text-white hover:bg-slate-600 rounded-r-lg"
                          >
                            +
                          </button>
                        </div>
                        <button
                          onClick={() => removeFromCart(item.id)}
                          className="text-red-400 hover:text-red-300"
                        >
                          <X className="w-5 h-5" />
                        </button>
                      </div>
                    </div>
                  ))}
                  
                  <div className="mt-6 pt-6 border-t border-slate-700">
                    <div className="flex justify-between items-center mb-4">
                      <span className="text-xl text-white">Total:</span>
                      <span className="text-2xl font-bold text-cyan-400">${getTotal()}</span>
                    </div>
                    <button
                      onClick={handleCheckout}
                      className="w-full bg-cyan-500 hover:bg-cyan-600 text-white py-3 rounded-lg font-semibold transition-colors"
                    >
                      Proceed to Checkout
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Checkout Modal */}
      {showCheckout && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-slate-800 rounded-xl max-w-2xl w-full max-h-[80vh] overflow-auto border border-slate-700">
            <div className="sticky top-0 bg-slate-800 p-6 border-b border-slate-700 flex justify-between items-center">
              <h2 className="text-2xl font-bold text-white">
                {paymentData ? 'Payment Details' : 'Select Payment Method'}
              </h2>
              <button onClick={() => setShowCheckout(false)} className="text-slate-400 hover:text-white">
                <X className="w-6 h-6" />
              </button>
            </div>
            
            <div className="p-6">
              {error && (
                <div className="mb-4 p-4 bg-red-500/20 border border-red-500 rounded-lg text-red-300">
                  {error}
                </div>
              )}

              {!paymentData && !loading && (
                <>
                  <div className="mb-6 p-4 bg-slate-700/50 rounded-lg">
                    <p className="text-slate-300 mb-2">Order Total</p>
                    <p className="text-3xl font-bold text-white">${getTotal()}</p>
                  </div>

                  <div className="mb-6">
                    <label className="block text-white mb-2">Email (for order confirmation)</label>
                    <input
                      type="email"
                      value={customerEmail}
                      onChange={(e) => setCustomerEmail(e.target.value)}
                      placeholder="your@email.com"
                      className="w-full px-4 py-2 bg-slate-700 text-white rounded-lg border border-slate-600 focus:border-cyan-500 focus:outline-none"
                    />
                  </div>

                  <div className="mb-6 p-4 bg-slate-700/30 rounded-lg border border-slate-600">
                    <h3 className="text-white font-semibold mb-4">Delivery Address *</h3>
                    
                    <div className="space-y-3">
                      <div>
                        <input
                          type="text"
                          value={deliveryAddress.name}
                          onChange={(e) => setDeliveryAddress({...deliveryAddress, name: e.target.value})}
                          placeholder="Full Name *"
                          required
                          className="w-full px-4 py-2 bg-slate-700 text-white rounded-lg border border-slate-600 focus:border-cyan-500 focus:outline-none"
                        />
                      </div>
                      
                      <div>
                        <input
                          type="tel"
                          value={deliveryAddress.phone}
                          onChange={(e) => setDeliveryAddress({...deliveryAddress, phone: e.target.value})}
                          placeholder="Phone Number"
                          className="w-full px-4 py-2 bg-slate-700 text-white rounded-lg border border-slate-600 focus:border-cyan-500 focus:outline-none"
                        />
                      </div>
                      
                      <div>
                        <input
                          type="text"
                          value={deliveryAddress.street}
                          onChange={(e) => setDeliveryAddress({...deliveryAddress, street: e.target.value})}
                          placeholder="Street Address *"
                          required
                          className="w-full px-4 py-2 bg-slate-700 text-white rounded-lg border border-slate-600 focus:border-cyan-500 focus:outline-none"
                        />
                      </div>
                      
                      <div className="grid grid-cols-2 gap-3">
                        <input
                          type="text"
                          value={deliveryAddress.city}
                          onChange={(e) => setDeliveryAddress({...deliveryAddress, city: e.target.value})}
                          placeholder="City *"
                          required
                          className="w-full px-4 py-2 bg-slate-700 text-white rounded-lg border border-slate-600 focus:border-cyan-500 focus:outline-none"
                        />
                        
                        <input
                          type="text"
                          value={deliveryAddress.state}
                          onChange={(e) => setDeliveryAddress({...deliveryAddress, state: e.target.value})}
                          placeholder="State/Province"
                          className="w-full px-4 py-2 bg-slate-700 text-white rounded-lg border border-slate-600 focus:border-cyan-500 focus:outline-none"
                        />
                      </div>
                      
                      <div className="grid grid-cols-2 gap-3">
                        <input
                          type="text"
                          value={deliveryAddress.zip}
                          onChange={(e) => setDeliveryAddress({...deliveryAddress, zip: e.target.value})}
                          placeholder="ZIP/Postal Code *"
                          required
                          className="w-full px-4 py-2 bg-slate-700 text-white rounded-lg border border-slate-600 focus:border-cyan-500 focus:outline-none"
                        />
                        
                        <input
                          type="text"
                          value={deliveryAddress.country}
                          onChange={(e) => setDeliveryAddress({...deliveryAddress, country: e.target.value})}
                          placeholder="Country *"
                          required
                          className="w-full px-4 py-2 bg-slate-700 text-white rounded-lg border border-slate-600 focus:border-cyan-500 focus:outline-none"
                        />
                      </div>
                    </div>
                    
                    <p className="text-slate-400 text-xs mt-3">* Required fields</p>
                  </div>

                  <p className="text-slate-400 mb-4 text-sm">Select your preferred cryptocurrency:</p>

                  <div className="space-y-4">
                    {cryptoOptions.map(crypto => (
                      <button
                        key={crypto.id}
                        onClick={() => createCryptoPayment(crypto)}
                        disabled={loading}
                        className="w-full p-4 bg-slate-700/50 rounded-lg border border-slate-600 hover:border-cyan-500 transition-all hover:shadow-lg hover:shadow-cyan-500/20 disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        <div className="flex justify-between items-center">
                          <div className="flex items-center gap-4">
                            <div className={`w-12 h-12 ${crypto.color} rounded-full flex items-center justify-center`}>
                              <Wallet className="w-6 h-6 text-white" />
                            </div>
                            <div className="text-left">
                              <h3 className="text-white font-semibold">{crypto.name}</h3>
                              <p className="text-slate-400 text-sm">{crypto.symbol}</p>
                            </div>
                          </div>
                          <div className="text-right">
                            <p className="text-slate-400 text-sm">Pay with {crypto.symbol}</p>
                          </div>
                        </div>
                      </button>
                    ))}
                  </div>
                </>
              )}

              {loading && (
                <div className="text-center py-8">
                  <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-cyan-500 mx-auto mb-4"></div>
                  <p className="text-white text-xl mb-2">Creating Payment...</p>
                  <p className="text-slate-400">Please wait while we set up your crypto payment</p>
                </div>
              )}

              {paymentData && !loading && (
                <div className="space-y-6">
                  <div className="bg-green-500/20 border border-green-500 rounded-lg p-4">
                    <p className="text-green-300 font-semibold">✅ Payment Created Successfully!</p>
                    <p className="text-slate-300 text-sm mt-1">Order ID: {paymentData.orderId}</p>
                  </div>

                  <div className="bg-slate-700/50 rounded-lg p-4">
                    <p className="text-white font-semibold mb-2">Pay with {paymentData.selectedCrypto.name}</p>
                    <p className="text-slate-300 text-sm mb-4">Choose your payment method:</p>

                    <button
                      onClick={openCoinbasePayment}
                      className="w-full bg-cyan-500 hover:bg-cyan-600 text-white py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2 mb-3"
                    >
                      <ExternalLink className="w-5 h-5" />
                      Open Coinbase Payment Page
                    </button>

                    <p className="text-slate-400 text-xs text-center mb-4">
                      Coinbase Commerce will show QR code and payment address
                    </p>
                  </div>

                  <div className="bg-slate-700/50 rounded-lg p-4">
                    <p className="text-white font-semibold mb-3">Payment Information</p>
                    <div className="space-y-2 text-sm">
                      <div className="flex justify-between">
                        <span className="text-slate-400">Amount (USD):</span>
                        <span className="text-white font-semibold">${getTotal()}</span>
                      </div>
                      {paymentData.pricing && Object.entries(paymentData.pricing).map(([key, value]) => (
                        <div key={key} className="flex justify-between">
                          <span className="text-slate-400">{key.toUpperCase()}:</span>
                          <span className="text-cyan-400 font-mono">{value.amount}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="bg-blue-500/20 border border-blue-500 rounded-lg p-4">
                    <p className="text-blue-300 text-sm">
                      💡 <strong>Next Steps:</strong><br/>
                      1. Click the button above to open Coinbase payment page<br/>
                      2. Send the exact crypto amount shown<br/>
                      3. You'll receive confirmation once payment is verified<br/>
                      4. Your order will be processed automatically
                    </p>
                  </div>

                  <button
                    onClick={resetStore}
                    className="w-full bg-slate-600 hover:bg-slate-500 text-white py-2 rounded-lg transition-colors"
                  >
                    Start New Order
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CryptoStore;